import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContainer,
  DatePicker,
  getSpacing,
  handleHelperText,
  nationalIdValidation,
  TextInput,
  ToggleButton,
  useAlert,
  mobileValidation,
} from '@rahtab/ui';
import { Screen } from '@rahtab/stack-navigator';
import moment from 'moment-jalaali';
import { fixNumbers, unhandledErrorGenerator, useRequest } from '@rahtab/auth/lib/token-based-auth';
import * as yup from 'yup';

const iranianCustomer = 'شهروند ایرانی';
const foreignCustomer = 'اتباع خارجه';
const iranianLabel = 'کدملی';
const foreignLabel = 'کداختصاصی (فیدا)';

const iranianSchema = yup.object().shape({
  iranianNationalCode: nationalIdValidation,
  mobile: mobileValidation,
});

const foreignSchema = yup.object().shape({
  mobile: mobileValidation,
});

const RegisterCustomers = () => {
  const [activeTab, setActiveTab] = useState(iranianCustomer);
  const [userId, setUserId] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [errors, setErrors] = useState<yup.ValidationError | null>(null);
  const [registerLoading, setRegisterLoading] = useState(false);
  const alert = useAlert();
  const request = useRequest();
  console.log('date', birthdate);

  const handleCustomer = () => {
    if (activeTab === iranianCustomer) return `NationalCode=${fixNumbers(userId)}`;
    if (activeTab === foreignCustomer) return `FidaCode=${fixNumbers(userId)}`;
  };

  const validate = () => {
    if (activeTab === iranianCustomer) {
      iranianSchema
        .validate(
          {
            iranianNationalCode: userId,
            mobile: mobileNo,
          },
          {
            abortEarly: false,
          },
        )
        .then(() => {
          setErrors(null);
          registerNewCustomer();
        })
        .catch((err) => {
          setErrors(err);
        });
    } else if (activeTab === foreignCustomer) {
      foreignSchema
        .validate(
          {
            mobile: mobileNo,
          },
          {
            abortEarly: false,
          },
        )
        .then(() => {
          setErrors(null);
          registerNewForeignCustomer();
        })
        .catch((err) => {
          setErrors(err);
        });
    }
  };

  const registerNewCustomer = async () => {
    setRegisterLoading(true);
    try {
      const register = await request<RegisterStatus>('RegisterCustomer', {
        params: `${handleCustomer()}&MobileNo=${fixNumbers(mobileNo)}&BirthDate=${birthdate.replace(/\//g, '')}`,
      });
      setRegisterLoading(false);
      if (register.valid === 'true') {
        console.log('regvalid', register);
        alert({ message: 'شهروند با موفقیت ثبت‌نام شد.' });
      } else if (register.valid === 'false') {
        console.log('regInvalid', register);
        if (register.error) alert({ message: register.error });
        else alert(unhandledErrorGenerator(503));
      } else {
        alert(unhandledErrorGenerator(504));
      }
    } catch (err) {
      setRegisterLoading(false);
      console.log('register error', err);
    }
  };

  const registerNewForeignCustomer = async () => {
    setRegisterLoading(true);
    try {
      const register = await request<RegisterStatus>('RegisterCustomerForiegn', {
        params: `${handleCustomer()}&MobileNo=${fixNumbers(mobileNo)}&BirthDate=${birthdate.replace(/\//g, '')}`,
      });
      console.log('reg', register);
      setRegisterLoading(false);
      if (register.valid === 'true') {
        console.log('regvalid', register);
        alert({ message: 'شهروند با موفقیت ثبت‌نام شد.' });
      } else if (register.valid === 'false') {
        console.log('regInvalid', register);
        if (register.error) {
          if (register.error === 'immigrant_not_found')
            alert({ title: 'خطا', message: 'اطلاعات وارد شده با اطلاعات ثبتی مغایرت دارد.' });
          else if (register.error === 'user_exists')
            alert({ title: 'خطا', message: 'کاربری با این شماره تلفن همراه/کد اختصاصی در رهتاب ثبت‌نام کرده است.' });
          else if (register.error === 'service_unavailable')
            alert({
              title: 'خطا',
              message: 'در حال حاضر سرویس کنترل اطلاعات اتباع خارجه از خارج از شبکه رهتاب در دسترس نیست.',
            });
          else if (register.error === 'invalid_request') alert({ title: 'خطا', message: 'درخواست شما نامعتبر است.' });
        } else alert(unhandledErrorGenerator(503));
      } else {
        alert(unhandledErrorGenerator(504));
      }
    } catch (err) {
      setRegisterLoading(false);
      console.log('foreign register error', err);
    }
  };
  return (
    <Screen
      transparentLoading={registerLoading}
      title="ثبت نام شهروندان"
      renderMain={() => {
        return (
          <Card style={{ margin: getSpacing() }}>
            <CardContainer>
              <ToggleButton
                selected={activeTab}
                color="secondary"
                onPress={(tabName) => {
                  setErrors(null);
                  setActiveTab(tabName);
                }}>
                <ToggleButton.Item label={iranianCustomer} />
                <ToggleButton.Item label={foreignCustomer} />
              </ToggleButton>
              <TextInput
                onChangeText={setUserId}
                value={userId}
                helperText={handleHelperText('iranianNationalCode', errors)}
                label={activeTab === iranianCustomer ? iranianLabel : foreignLabel}
                placeholder={`${activeTab === iranianCustomer ? iranianLabel : foreignLabel} شهروند را وارد نمایید.`}
                keyboardType="numeric"
              />
              <TextInput
                onChangeText={setMobileNo}
                helperText={handleHelperText('mobile', errors)}
                value={mobileNo}
                label={'شماره همراه'}
                placeholder={'شماره همراه شهروند را وارد نمایید.'}
                keyboardType="numeric"
              />
              <DatePicker
                label="تاریخ تولد"
                placeholder="تاریخ تولد شهروند را وارد نمایید."
                value={birthdate}
                onConfirm={setBirthdate}
                after={moment().subtract(100, 'year').startOf('day').toDate()}
                before={moment().startOf('day').toDate()}
              />
              <Button
                disabled={!(userId && mobileNo && birthdate)}
                text="ثبت‌نام شهروند"
                color="secondary"
                onPress={() => validate()}
              />
            </CardContainer>
          </Card>
        );
      }}
    />
  );
};

export default RegisterCustomers;

interface RegisterStatus {
  valid: string;
  error: string;
}
